import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  input: {
    fontSize: (props) => props.fontSize ?? "0.875rem",
  },
  option: {
    fontSize: (props) => props.fontSize ?? "0.75rem",
  },
}));

const ComboBox = (props) => {
  const { disableUnderline, disableClearable, margin, ...rest } = props;

  const classes = useStyles(rest);
  return (
    <Autocomplete
      {...rest}
      classes={{
        input: classes.input,
        option: classes.option,
      }}
      disableClearable={disableClearable ?? true}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={props.autoFocus}
          label={props.label}
          variant={props.variant ?? "standard"}
          margin={props.margin ?? "dense"}
          inputProps={{
            ...params.inputProps,
          }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: disableUnderline,
            style: { paddingBottom: 0 },
          }}
          InputLabelProps={{
            style: { fontSize: "0.75rem" },
          }}
        />
      )}
    />
  );
};

export default ComboBox;
